// src/environment.prod.ts

export const environment = {
  production: true,
  url: 'https://kraeutersaat.de',
  apiUrl: 'https://kraeutersaat.de/api',
  liveUrl: 'https://kraeutersaat.de',
  liveApiUrl: 'https://kraeutersaat.de/api',
};